import styled from 'styled-components';
import { Popconfirm } from "antd";
import React, { ReactNode } from "react";
import { CustomAction, Identifiable, RecordModel, RecordsetFilters } from "../types/core";
import RecordDrawer from "./RecordDrawer";

const Container = styled.div`
`;

interface RecordCustomActionProps<T> {
  customAction: CustomAction<T>;
  recordModel: RecordModel<T>;
  record: T;
  doRecordAction: any;
  recordsetFilters?: RecordsetFilters;
}

function RecordCustomAction<T extends Identifiable>(props: RecordCustomActionProps<T>) {
  const { customAction, recordModel, doRecordAction, record: r } = props;
  const method = customAction.method;
  const alternativePkName = recordModel?.primaryKeyName;
  const recordPk = alternativePkName ? (r as any)[alternativePkName] : r.id;

  const actionBtn = (
    <a style={{ opacity: (customAction.disabled ? customAction?.disabled(r) : false) ? 0.33 : 1 }}>
      {typeof customAction.icon === 'function' ? customAction.icon(r) : customAction.icon}
      {' '}
      {typeof customAction.name === 'function' ? customAction.name(r) : customAction.name}
    </a>
  )

  return (
    <Container>
      {method === 'post' ? (
        <div>
          <RecordDrawer
            customButton={actionBtn}
            recordModel={recordModel}
            customAction={customAction}
            recordInstance={r}
            customRecordName={`${recordModel.name} "${recordModel.toString(r)}"`}
            recordsetFilters={props.recordsetFilters}
          />
        </div>
      ) : (
        <Popconfirm
          title={`Perform ${customAction.name} now?`}
          onConfirm={() => doRecordAction(customAction.path, undefined, undefined, customAction.isDetail ? recordPk : undefined)}
          okText="Yes"
          disabled={customAction.disabled ? customAction.disabled(r) : false}
        >
          {actionBtn}
        </Popconfirm>
      )}
    </Container>
  )
}

export default RecordCustomAction;
